import React from 'react'
import { t } from 'ttag'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { Button } from 'components/shared/Button/Button'
import { PlusCircleIcon } from 'components/shared/Icon/Icon'
import styles from './DepartmentListing.module.scss'
import { DepartmentListingTable } from './DepartmentListingTable/DepartmentListingTable'
import { DeleteDepartmentModal } from 'components/modals/DeleteDepartmentModal/DeleteDepartmentModal'
import { DeleteDepartmentWarningModal } from 'components/modals/DeleteDepartmentWarningModal/DeleteDepartmentWarningModal'
import { DepartmentManagerModal } from 'components/modals/DepartmentManagerModal/DepartmentManagerModal'
import { useDepartments } from './hooks'

export const DepartmentListing = () => {
  const { state, handlers } = useDepartments()

  const {
    search,
    department,
    isDeleteDepartmentOpen,
    isDeleteDepartmentWarningOpen,
    isDepartmentManagerOpen,
  } = state
  const {
    handleDepartmentManagerClose,
    handleDepartmentManagerOpen,
    handleDepartmentManagerConfirm,
    handleDeleteDepartmentClose,
    handleDeleteDepartmentConfirm,
    handleDeleteDepartmentWarningClose,
    handleDeleteDepartmentWarningConfirm,
    handleDeleteDepartmentWarningOpen,
    handleEdit,
    handleDelete,
    setSearch,
  } = handlers

  return (
    <Pane tagName="article">
      <Pane.Header title={t`Departments`} className={styles.header}>
        <SearchWidget query={search} onChange={setSearch} />
        <Button
          color="primary"
          icon={PlusCircleIcon}
          label={t`Add Department`}
          size="small"
          variant="filled"
          onClick={handleDepartmentManagerOpen}
        />
      </Pane.Header>
      <DepartmentListingTable
        search={search}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleDeleteDepartmentWarningOpen={handleDeleteDepartmentWarningOpen}
      />
      <DepartmentManagerModal
        onCancel={handleDepartmentManagerClose}
        onClose={handleDepartmentManagerClose}
        onConfirm={handleDepartmentManagerConfirm}
        isOpen={isDepartmentManagerOpen}
        {...{ department }}
      />
      <DeleteDepartmentModal
        onCancel={handleDeleteDepartmentClose}
        onClose={handleDeleteDepartmentClose}
        onConfirm={handleDeleteDepartmentConfirm}
        isOpen={isDeleteDepartmentOpen}
      />
      <DeleteDepartmentWarningModal
        onClose={handleDeleteDepartmentWarningClose}
        onConfirm={handleDeleteDepartmentWarningConfirm}
        isOpen={isDeleteDepartmentWarningOpen}
      />
    </Pane>
  )
}
